import styled from 'styled-components'

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    padding: 8px;
    border: none;
    border-radius: 8px;
    background: #f0f0f0;
    color: #4c4c4c;
    cursor: pointer;

    &:hover {
      color: #213f68;
      background: rgba(158, 207, 250, 0.25);
    }
  }

  h2 {
    margin: 0;
    color: #002a6d;
    font-family: Roboto, sans-serif;
    font-size: 20px;
    font-weight: 700;
    line-height: 28px;
  }
`

export const Description = styled.p`
  margin: 0;
  color: #363636;
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
`

export const TableSection = styled.div`
  width: 100%;
`

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 16px;
  width: 100%;

  .back {
    height: 40px;
    padding: 0 12px;
    border: none;
    border-radius: 8px;
    background: #e7f3fe;
    color: #2684ff;
    font-family: Roboto, sans-serif;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;

    &:hover {
      opacity: 0.92;
    }
  }

  .actions {
    display: flex;
    gap: 8px;
  }

  .secondary,
  .primary {
    height: 40px;
    padding: 0 12px;
    border: none;
    border-radius: 8px;
    font-family: Roboto, sans-serif;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
  }

  .secondary {
    background: #f0f0f0;
    color: #4c4c4c;

    &:hover {
      opacity: 0.92;
    }
  }

  .primary {
    background: #2684ff;
    color: #fff;

    &:hover:not(:disabled) {
      opacity: 0.92;
    }

    &:disabled {
      opacity: 0.48;
      cursor: not-allowed;
    }
  }
`

export const Options = styled.span`
  button {
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    min-width: 32px;
    padding: 0 !important;
    border: none;
    background-color: #f0f0f0 !important;
    border-radius: 8px;
    color: #4c4c4c !important;

    svg {
      transition: 200ms;
    }

    &:hover svg {
      opacity: 0.7;
    }
  }
`

export const RankmiTableWrapper = styled.div`
  width: 100%;

  .ant-table-wrapper {
    margin-top: -9px;
  }
`
